<div class="{{mainClassName}} {{additionalClassName}}" [class.disabled]="disabled">
  @if (label) {
    <div class="sw-dropdown-label">{{ label | translate }}</div>
  }

  <div
    class="dropdown-container"
    [sfElPositionDirective]="null"
    #myAction="sfElPositionDirective"
    [distance]="300"
    [class.active]="dropdownState"
    (sfClickOutside)="onClickOutside()">

    <div class="selected-item" (click)="onToggleDropdownState(); myAction.calculate()">

      @if (selectedItem && selectedItem[keyName]) {
        <span
          class="inner-text s-ellipsis {{selectedItem['classname'] || ''}}"
          [style.font-family]="selectedItem['fontFamily'] ?? 'inherit'"
          [innerHTML]="selectedItem[keyName] | translate"
        ></span>
      } @else {
        <span class="inner-text s-ellipsis sw-placeholder">{{ placeHolder | translate }}</span>
      }

      <i class="chevron-down ph ph-caret-down"></i>
    </div>

    @if (dropdownState) {
      <div class="dropdown-items-list">
        @if (hasSearch && items.length > 7) {
          <div class="sw-search-container">
            <input
              #SearchRef
              class="sw-input-search"
              type="text"
              [placeholder]="searchPlaceHolder"
              [(ngModel)]="searchQuery">
          </div>
        }

        <div class="items-container">
          <div class="all-dropdown-items">
            @if (unSelectable) {
              <div class="dropdown-item-el unset" (click)="onUnset()">{{ placeHolder }}</div>
            }

            @for (item of items | sfFilter : searchQuery : keyName; track item) {
              @if (!item[hideByKeyName]) {
                <div
                  class="dropdown-item-el {{item['classname'] || ''}}"
                  [style.font-family]="item['fontFamily'] ?? 'inherit'"
                  [title]="showTitle ? (item[keyName].length > 35 ? (item[keyName] | translate) : '') : ''"
                  [class.active]="item === selectedItem"
                  [innerHTML]="item[keyName] | translate"
                  (click)="onSelectItem(item)"
                ></div>
              }
            }
          </div>
        </div>
      </div>
    }

  </div>
</div>



